import { render } from "./VillageNpc3.vue?vue&type=template&id=4f740146&scoped=true"
import script from "./VillageNpc3.vue?vue&type=script&lang=js"
export * from "./VillageNpc3.vue?vue&type=script&lang=js"

import "./VillageNpc3.vue?vue&type=style&index=0&id=4f740146&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f740146"]])

export default __exports__